module.exports = __webpack_public_path__ + "img/5.5bd1de4a.png";